import { colors, createTheme } from '@atlaskit/theme';
import { uniqueId } from 'lodash';
import React, { useMemo, useRef } from 'react';
import { LEFT_ARROW, RIGHT_ARROW } from '../utils/keyboard';
import { Label, Toggle } from './';
import { Container } from './switch-view.styles';
const defaultTheme = () => ({
    color: colors.N400,
    borderBottomStyle: 'solid',
    fontWeight: 400,
    toggleBorderColor: colors.N90,
    toggleBackGroundColor: colors.N90
});
const Theme = createTheme(defaultTheme);
export function SwitchView({ left, right, ariaLabel, togglePosition = 'left', onSelectTogglePosition, theme = defaultTheme }) {
    const id = useMemo(() => uniqueId('bxpkit-switch-'), []);
    const selectedItem = togglePosition === 'left' ? left : right;
    const toggleRef = useRef(null);
    function selectTogglePosition(selectedTogglePosition) {
        toggleRef.current.focus();
        onSelectTogglePosition(selectedTogglePosition);
    }
    function createLabelOnClickMouseEventHandler(position) {
        return (event) => {
            selectTogglePosition(position);
            event.preventDefault();
        };
    }
    return (React.createElement(Theme.Provider, { value: theme },
        React.createElement(Theme.Consumer, null, (tokens) => {
            const { color, borderBottomStyle, fontWeight, toggleBorderColor, toggleBackGroundColor } = tokens;
            return (React.createElement(Container, { onKeyDown: (event) => {
                    switch (event.keyCode) {
                        case LEFT_ARROW:
                            selectTogglePosition('left');
                            break;
                        case RIGHT_ARROW:
                            selectTogglePosition('right');
                            break;
                    }
                } },
                React.createElement(Label, { htmlFor: id, isSelected: togglePosition === 'left', selectedColor: color, borderBottomStyle: borderBottomStyle, fontWeight: fontWeight, onClick: createLabelOnClickMouseEventHandler('left') }, left.label),
                React.createElement(Toggle, { id: id, innerRef: toggleRef, ariaLabel: ariaLabel, position: togglePosition, value: selectedItem.value.toString(), borderColor: toggleBorderColor, backGroundColor: toggleBackGroundColor, onClick: () => {
                        switch (togglePosition) {
                            case 'left':
                                return selectTogglePosition('right');
                            case 'right':
                                return selectTogglePosition('left');
                        }
                    } }),
                React.createElement(Label, { htmlFor: id, isSelected: togglePosition === 'right', selectedColor: color, borderBottomStyle: borderBottomStyle, fontWeight: fontWeight, onClick: createLabelOnClickMouseEventHandler('right') }, right.label)));
        })));
}
//# sourceMappingURL=switch-view.js.map